function detectClientSlug(): string {
    const segments = window.location.pathname.split('/').filter(Boolean);
    return segments[0] ?? 'default';
}

export { detectClientSlug };
